export default {
  root: function root() {
    return {
      textAlign: 'right'
    };
  }
};
//# sourceMappingURL=dialogFooterStyles.js.map
